import { ReactElement } from 'react';

import {
  Button as ToqioButton,
  ButtonProps as ToqioButtonProps,
  SIZE,
  BUTTON_VARIANTS,
} from '@toqio/toqio-web-components';

import { VariantButtonProps } from './button.d';

/**
 * TOQIO BUTTON - no exportable
 * use specific components for different variants instead
 */
const Button = ({
  onClick,
  children,
  className = '',
  disabled = false,
  variant,
  size = SIZE.M,
  type,
  responsive = true,
  leftIcon,
  ...rest
}: ToqioButtonProps): ReactElement => {
  return (
    <ToqioButton
      className={className}
      onClick={onClick}
      disabled={disabled}
      variant={variant}
      size={size}
      responsive={responsive}
      leftIcon={leftIcon}
      type={type}
      {...rest}
    >
      {children}
    </ToqioButton>
  );
};

export const PrimaryButtonXS = ({ children, ...props }: VariantButtonProps): ReactElement => {
  return (
    <Button {...props} variant={BUTTON_VARIANTS.PRIMARY} size={SIZE.XS}>
      {children}
    </Button>
  );
};

export const PrimaryButtonS = ({ children, ...props }: VariantButtonProps): ReactElement => {
  return (
    <Button {...props} variant={BUTTON_VARIANTS.PRIMARY} size={SIZE.S}>
      {children}
    </Button>
  );
};

export const PrimaryButtonM = ({ children, ...props }: VariantButtonProps): ReactElement => {
  return (
    <Button {...props} variant={BUTTON_VARIANTS.PRIMARY} size={SIZE.M}>
      {children}
    </Button>
  );
};

export const SecondaryButtonXS = ({ children, ...props }: VariantButtonProps): ReactElement => {
  return (
    <Button {...props} variant={BUTTON_VARIANTS.SECONDARY} size={SIZE.XS}>
      {children}
    </Button>
  );
};

export const SecondaryButtonS = ({ children, ...props }: VariantButtonProps): ReactElement => {
  return (
    <Button {...props} variant={BUTTON_VARIANTS.SECONDARY} size={SIZE.S}>
      {children}
    </Button>
  );
};

export const SecondaryButtonM = ({ children, ...props }: VariantButtonProps): ReactElement => {
  return (
    <Button {...props} variant={BUTTON_VARIANTS.SECONDARY} size={SIZE.M}>
      {children}
    </Button>
  );
};

export const AccentButtonXS = ({ children, ...props }: VariantButtonProps): ReactElement => {
  return (
    <Button {...props} variant={BUTTON_VARIANTS.ACCENT} size={SIZE.XS}>
      {children}
    </Button>
  );
};

export const AccentButtonS = ({ children, ...props }: VariantButtonProps): ReactElement => {
  return (
    <Button {...props} variant={BUTTON_VARIANTS.ACCENT} size={SIZE.S}>
      {children}
    </Button>
  );
};

export const AccentButtonM = ({ children, ...props }: VariantButtonProps): ReactElement => {
  return (
    <Button {...props} variant={BUTTON_VARIANTS.ACCENT} size={SIZE.M}>
      {children}
    </Button>
  );
};

export const CriticalButtonXS = ({ children, ...props }: VariantButtonProps): ReactElement => {
  return (
    <Button {...props} variant={BUTTON_VARIANTS.CRITICAL} size={SIZE.XS}>
      {children}
    </Button>
  );
};

export const CriticalButtonS = ({ children, ...props }: VariantButtonProps): ReactElement => {
  return (
    <Button {...props} variant={BUTTON_VARIANTS.CRITICAL} size={SIZE.S}>
      {children}
    </Button>
  );
};

export const CriticalButtonM = ({ children, ...props }: VariantButtonProps): ReactElement => {
  return (
    <Button {...props} variant={BUTTON_VARIANTS.CRITICAL} size={SIZE.M}>
      {children}
    </Button>
  );
};
